module.exports = __webpack_public_path__ + "static/media/web_signup.18e4127d.png";